module.exports = __webpack_public_path__ + "img/grandparents-min.b6509ec6.jpg";